import React from 'react'
import TitlePage from '../../../common/TitlePage';
import { makeStyles } from "@material-ui/core/styles";
import { Box } from '@material-ui/core';
import CircleIcon from "./../../../common/CircleIcon"



const useStyles = makeStyles((theme) => ({
    root: {
        padding: "100px 0"
    },
    color: {
        color: theme.palette.light.type2
    },
    content: {
        marginTop: 65,
        width: "60%",
        margin: "auto",
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
        [theme.breakpoints.down("sm")]: {
            width: "90%",
            marginTop: 80,
        }
    },
    item: {
        margin: "30px 1%",
        width: "23%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        "& span": {
            marginTop: 10,
            fontSize: theme.fontSize.regular
        },
        [theme.breakpoints.down("md")]: {
            minWidth: "48%",
        },
        [theme.breakpoints.down("xs")]: {
            width: "100%"
        }
    },
    
    title:{
        whiteSpace:'nowrap'
    }
}))

export default function Service() {
    const classes = useStyles()

    return (
        <div className={classes.root}>
            <Box textAlign="center">
                <TitlePage position="bottomCenter" padding="0px 0px">
                    چرا با سامانه آنلاین کارگزاری <span className={classes.color}>پویان</span>  ترید کنیم؟
                </TitlePage>
                <Box className={classes.content}>
                    {
                        data.map((item, ind) => (
                            <a 
                            key={ind}
                            //  target="_blank"
                              href={item.link} className={classes.item}>
                                <div>
                                    <CircleIcon id={item.icon} />
                                    <span className={classes.title} >{item.title}</span>
                                </div>
                            </a>
                        ))
                    }
                </Box>
            </Box>
        </div>
    )
}


let data = [
    { title: "سرعت در انجام معاملات ", icon: "kala", link: "#" },
    { title: "رابط کاربری  کاربر پسند", icon: "trades3", link: "#" },
    { title: "ارسال چندین سفارش همزمان ", icon: "system_online", link: "#" },
    { title: "نمودار تحلیل تکنیکال", icon: "train", link: "#" },
    // { title: "سامانه آفلاین", icon: "system_customer", link: "https://pishro.irbrokersite.ir/" },
    // { title: "سامانه آنلاین", icon: "system_online", link: "https://pishro.exirbroker.ir/" },
    // { title: "سامانه سهام عدالت", icon: "system_justice", link: "https://se-simabgoon.rayanbroker.ir/" },
    // { title: "آموزش", icon: "train", link: "#" },
]
